var _rect, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgContactCall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 77,
    height: 77,
    viewBox: "0 0 77 77",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 77,
    height: 77,
    rx: 5,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48.7499 24L54.8487 29.5541L48.7499 35.1081",
    stroke: "#F8B326",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M42.6504 29.5541H54.8479",
    stroke: "#F8B326",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M53.3231 46.1052V50.2707C53.3249 50.6574 53.2379 51.0402 53.0678 51.3945C52.8976 51.7488 52.6482 52.0669 52.3353 52.3283C52.0224 52.5898 51.653 52.7888 51.2507 52.9127C50.8485 53.0366 50.4222 53.0826 49.9993 53.0478C45.3076 52.5835 40.8009 51.1235 36.8413 48.785C33.1574 46.6532 30.0341 43.8088 27.6932 40.4539C25.1164 36.8316 23.5128 32.7074 23.0124 28.4155C22.9743 28.0315 23.0244 27.6445 23.1595 27.2791C23.2946 26.9138 23.5118 26.578 23.7972 26.2933C24.0826 26.0085 24.43 25.781 24.8173 25.6253C25.2045 25.4695 25.6232 25.3889 26.0465 25.3885H30.6206C31.3605 25.3819 32.0778 25.6205 32.6389 26.0599C33.1999 26.4993 33.5664 27.1095 33.6699 27.7768C33.863 29.1098 34.221 30.4187 34.7372 31.6785C34.9423 32.1755 34.9867 32.7156 34.8651 33.2348C34.7435 33.7541 34.461 34.2307 34.0511 34.6083L32.1148 36.3717C34.2852 39.8479 37.4457 42.7261 41.2629 44.7028L43.1992 42.9394C43.6138 42.566 44.1371 42.3088 44.7073 42.198C45.2775 42.0873 45.8706 42.1277 46.4163 42.3145C47.7996 42.7846 49.2369 43.1107 50.7007 43.2865C51.4413 43.3816 52.1177 43.7214 52.6012 44.2411C53.0848 44.7608 53.3417 45.4242 53.3231 46.1052Z",
    stroke: "#F8B326",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactCall);
export default __webpack_public_path__ + "static/media/contactCall.d3e538b36ce82d0bdcb0c7eba304b88d.svg";
export { ForwardRef as ReactComponent };